const editDialog = {
  state: {
    status: false,
    type: 'Client',
    client: {
      client_id: '',
      display_name: '',
      first_name: '',
      last_name: '',
      wechatID: '',
      mobile_number: '',
      contact_email: '',
      address: '',
      dob: '',
      gender: '',
      nationality: '',
      race: '',
      weight: '',
      display_lang: '',
      internal_id: '',
      MemberGTLCode: '',
      FamilyGTLCode: '',
      AgentGTLCode: '',
      MemberWIXID: '',
      MemberEmailID: ''
    }
  },
  mutations: {
    setEditDialogType (state:any, payload:any) {
      state.type = payload
      state.status = true
    },
    setEditDialogClient (state:any, payload:any) {
      state.client = payload
      state.client.dob = new Date(state.client.dob).getFullYear() + '-' + (new Date(state.client.dob).getMonth() + 1) + '-' + new Date(state.client.dob).getDate()
    }
  }
}

export default editDialog
